// Alternative approach: Use a global dialog manager that works with the main app
import { ref } from 'vue'

// Global state for dialogs
const dialogs = ref([])
let dialogIdCounter = 0

export const useDialogManager = () => {
  const addDialog = (spec) => {
    const id = ++dialogIdCounter
    const dialog = {
      id,
      ...spec,
      show: true
    }
    dialogs.value.push(dialog)
    return id
  }

  const removeDialog = (id) => {
    const index = dialogs.value.findIndex(d => d.id === id)
    if (index > -1) {
      dialogs.value.splice(index, 1)
    }
  }

  const closeDialog = (id) => {
    const dialog = dialogs.value.find(d => d.id === id)
    if (dialog) {
      dialog.show = false
      // Remove after animation
      setTimeout(() => removeDialog(id), 300)
    }
  }

  return {
    dialogs,
    addDialog,
    removeDialog,
    closeDialog
  }
}

// Simple API similar to LaunchDialog
export const SimpleDialog = {
  open(spec = {}) {
    console.log('SimpleDialog.open called with:', spec)
    const { addDialog } = useDialogManager()
    return addDialog(spec)
  },

  // Get all active dialogs
  getActiveDialogs() {
    const { dialogs } = useDialogManager()
    return dialogs.value.filter(d => d.show)
  },

  // Close all dialogs
  closeAll() {
    const { dialogs, closeDialog } = useDialogManager()
    dialogs.value.forEach(dialog => {
      if (dialog.show) closeDialog(dialog.id)
    })
  },

  // Close top dialog only
  closeTop() {
    const active = this.getActiveDialogs()
    if (active.length > 0) {
      const { closeDialog } = useDialogManager()
      const topDialog = active[active.length - 1]
      closeDialog(topDialog.id)
    }
  },

  validationError() {
    return this.open({
      type: 'error',
      // title: 'Validation Error',
      // : 'Make sure all fields are valid before submitting the form.',
      message: 'Validation Error',
      subtitle: 'Please check for any required fields that are empty or contain invalid data.'
    })
  },

  error(message, options = {}) {
    return this.open({
      type: 'error',
      message,
      ...options
    })
  },

  warning(message, options = {}) {
    return this.open({
      type: 'warning',
      message,
      ...options
    })
  },

  info(message, options = {}) {
    return this.open({
      type: 'info',
      message,
      ...options
    })
  },

  success(message, options = {}) {
    return this.open({
      type: 'success',
      message,
      ...options
    })
  },

  confirm(message, options = {}) {
    return new Promise((resolve) => {
      this.open({
        type: 'confirm',
        message,
        showCancel: true,
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
        ...options
      })
    })
  }
}

